import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop"]
  static values = { days: Number }

  connect() {
    const key = `trialModalDismissed_day${this.daysValue}`
    if (!sessionStorage.getItem(key)) {
      document.body.style.overflow = "hidden"
    } else {
      this.element.remove()
    }
  }

  dismiss() {
    const key = `trialModalDismissed_day${this.daysValue}`
    sessionStorage.setItem(key, "true")
    this._close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.backdropTarget) {
      this.dismiss()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.dismiss()
    }
  }

  disconnect() {
    document.body.style.overflow = ""
  }

  _close() {
    document.body.style.overflow = ""
    this.element.remove()
  }
}
